module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero8.png?d91eb004";